import React from 'react'

import { twMerge } from 'tailwind-merge'

interface ErrorMessageProps {
  children: React.ReactNode
  className?: string
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ children, className }) => {
  return (
    <span
      className={twMerge(
        'text-red-600 dark:text-red-500 text-sm self-end',
        className,
      )}
    >
      {children}
    </span>
  )
}

ErrorMessage.displayName = 'ErrorMessage'

export default ErrorMessage
